<template>
    <modal @close="modeResetExperience">
        <template slot="header_title">
            Suppression
        </template>
        <template slot="main">
            <div class="main_delete_experience">
                <strong>Voulez-vous vraiment effacer définitivement cette expérience ?</strong>
                <br>Impossible d’annuler cette opération.
            </div>
        </template>
        <template slot="footer">
            <v-layout row wrap>
                <v-flex xs6>
                    <v-btn class="custom_btn_position custom_btn_color_red" @click="modeResetExperience">
                        <i class="fas fa-times fa-btn" />
                        <span v-if="!isMobile">Annuler</span>
                    </v-btn>
                </v-flex>
                <v-flex xs6>
                    <v-btn class="custom_btn_position custom_btn_color_blue" @click="localDeleteExperience">
                        <i class="fas fa-check fa-btn" />
                        <span v-if="!isMobile">Valider</span>
                    </v-btn>
                </v-flex>
            </v-layout>
        </template>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        name: 'ModalDeleteExperience',
        components: {
            modal: () => import('../../global/modal')
        },
        computed: {
            ...mapGetters('app', ['isMobile'])
        },
        methods: {
            ...mapActions('experiences', ['modeResetExperience', 'deleteExperience']),
            ...mapActions('app', ['showOverlay', 'hideOverlay']),
            localDeleteExperience: function () {
                this.showOverlay();
                this.deleteExperience().then(() => {
                    this.hideOverlay();
                    this.modeResetExperience();
                    this.$toasted.success('Suppression de(s) expérience(s) avec succés');
                }).catch((err) => {
                    this.hideOverlay();
                    this.modeResetExperience();
                    this.$toasted.error('Une erreur est apparu lors de la suppression de(s) expérience(s) : ' + err);
                });
            }
        }
    };
</script>

<style scoped>
    .main_delete_experience {
        padding: 20px;
    }
</style>
